"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttackPlaceDTO = exports.PlaceAttackDTO = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const GeoIp_1 = require("./GeoIp");
const Goal_1 = require("./Goal");
class PlaceAttackDTO {
}
exports.PlaceAttackDTO = PlaceAttackDTO;
let AttackPlaceDTO = (() => {
    class AttackPlaceDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], AttackPlaceDTO.prototype, "attackerId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], AttackPlaceDTO.prototype, "placeId", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], AttackPlaceDTO.prototype, "playerCoordinates", void 0);
    __decorate([
        class_validator_1.IsEnum(Goal_1.PlaceAttackPvEGoals || Goal_1.PlaceAttackPvPGoals),
        __metadata("design:type", String)
    ], AttackPlaceDTO.prototype, "goal", void 0);
    return AttackPlaceDTO;
})();
exports.AttackPlaceDTO = AttackPlaceDTO;
//# sourceMappingURL=PlaceAttack.js.map